import { Link, createFileRoute } from '@tanstack/react-router'
import { EmptyState } from '@/components/empty-state'
import { Button } from '@/components/ui/button'
import { findReport } from '@/features/reports/definitions'
import { ReportScreen } from '@/features/reports/report-screen'
import { requirePermission } from '@/lib/route-guards'
import { ROUTES } from '@/lib/routes'

/** Pantalla de un reporte del catálogo. */
export const Route = createFileRoute('/_app/reports/$reportId')({
  beforeLoad: requirePermission('reports:read'),
  component: ReportRoute,
})

function ReportRoute() {
  const { reportId } = Route.useParams()
  const report = findReport(reportId)
  if (!report) {
    return (
      <EmptyState
        title="Reporte no encontrado"
        description="El reporte que busca no existe. Elija uno del catálogo."
        action={
          <Button asChild>
            <Link to={ROUTES.reports}>Ver reportes</Link>
          </Button>
        }
      />
    )
  }
  return <ReportScreen key={report.id} report={report} />
}
